<script>
import TitleWithRow from '@/components(new)/UI/Typography/TitleWithRow/TitleWithRow.vue'
import Label from '@/components(new)/UI/Forms/Label/Label.vue'
import InputSelect from '@/components(new)/UI/Forms/InputSelect/InputSelect.vue'
import InputMultiTexts from '@/components(new)/UI/Forms/InputMultiTexts/InputMultiTexts.vue'
import AppInputDouble from '@/components(new)/UI/Forms/InputDouble/InputDouble'
import onlyInputNumbers from '@/components/mixins/OnlyInputNumber'

export default {
  mixins: [onlyInputNumbers],
  components: {
    TitleWithRow,
    Label,
    InputSelect,
    InputMultiTexts,
    AppInputDouble
  },
  props: {
    nomeAba: {
      type: String,
      required: true
    },
    anoSafra: {
      type: String
    },
    areaDestinada: {
      type: [String, Number]
    },
    dataInicio: {
      type: String
    },
    // validação dos campos para as práticas SPDG e SPDH
    praticasArray: {
      typeof: Array,
      require: false,
      default: null
    }
  },
  computed: {
    rules () {
      return !this.praticasArray ? 'required' : !this.praticasArray.length ? 'required' : ''
    }
  },
  methods: {
    updateAnoSafra (val) {
      this.$emit('update:anoSafra', val)
    },
    updateAreaDestinada (val) {
      this.$emit('update:areaDestinada', val)
    },
    updateDataInicio (val) {
      this.$emit('update:dataInicio', val)
    }
  }
}
</script>

<template>
  <div>
    <TitleWithRow title="Safras" />
    <el-row>
      <InputSelect
        label="Ano/Safra"
        :nomeAba="nomeAba"
        :obrigatorio="true"
        :rulesInput="rules"
        :opcoes="[
          {id: '2021/22', nome: '2021/22'},
          {id: '2022/23', nome: '2022/23'},
          {id: '2023/24', nome: '2023/24'},
          {id: '2024/25', nome: '2024/25'},
          {id: '2025/26', nome: '2025/26'},
        ]"
        :widthColumn="7"
        @input="updateAnoSafra"
        :value="anoSafra"
      />
      <validation-provider :rules="!praticasArray.length ? 'area' : ''" v-slot="{ errors }" :name="nomeAba + '/Área'">
        <el-col :span="7" class="ml-2">
          <Label label="Área" :obrigatorio="true" />
          <AppInputDouble
            :class="{ erro: errors.length, input: 'input' }"
            name='Área'
            :precision="2"
            :onkeypress="onlyInputNumbers"
            :showAppend ="true"
            @input="updateAreaDestinada"
            :value="areaDestinada"
          />
          <span class="help erro">{{ errors[0] }}</span>
        </el-col>
      </validation-provider>
      <validation-provider :rules="rules" v-slot="{ errors }" :name="nomeAba + '/Previsão de colheita (mês/ano)'">
        <el-col :span="7" style="margin-left: 1rem;">
          <Label label="Data de início da prática de plantio" :obrigatorio="true" />
            <el-date-picker
              type="month"
              placeholder="Selecione mês e ano"
              format="MM/yyyy"
              value-format="yyyy-MM-dd"
              style="width: 100%"
              @input="updateDataInicio"
              :value="dataInicio"
              :class="{'input erro' : errors.length}"
            />
          <span class="help erro">{{ errors[0] }}</span>
        </el-col>
      </validation-provider>
    </el-row>
  </div>
</template>



// WEBPACK FOOTER //
// src/components(new)/UI/Forms/FormulariosProntos/Safras/Safras.vue